import { render, staticRenderFns } from "./adstest.vue?vue&type=template&id=493ef16a&"
import script from "./adstest.vue?vue&type=script&lang=js&"
export * from "./adstest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports